import Hero from "./Hero";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import Screenshots from "./Screenshots";
import Benefits from "./Benefits";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import Footer from "./Footer";

// props:
//  C          -> tema activo (darkTheme / lightTheme) igual que el resto de la app
//  onLogin    -> abre AuthScreen en modo "login"
//  onRegister -> abre AuthScreen en modo "register"
//  onNavigate -> ("privacy" | "terms") muestra la página legal correspondiente
export default function Landing({ C, onLogin, onRegister, onNavigate }) {
  return (
    <div style={{ minHeight: "100vh", background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <style>{`
        @keyframes fadeIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
        @keyframes slideIn { from{opacity:0;transform:translateX(-12px)} to{opacity:1;transform:translateX(0)} }
        .cq-hero-title { font-size: 42px; }
        .cq-grid-3 { grid-template-columns: repeat(3, 1fr); }
        .cq-grid-2 { grid-template-columns: repeat(2, 1fr); }
        @media (max-width: 860px) { .cq-grid-3 { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 600px) {
          .cq-hero-title { font-size: 30px; }
          .cq-grid-3, .cq-grid-2 { grid-template-columns: 1fr; }
        }
        .cq-landing button:focus-visible, .cq-landing a:focus-visible {
          outline: 2px solid ${C.primary}; outline-offset: 2px;
        }
      `}</style>

      <div className="cq-landing">
        {/* Nav */}
        <header id="inicio" style={{
          position: "sticky", top: 0, zIndex: 50, height: 62,
          background: `${C.bgSidebar}E8`, backdropFilter: "blur(14px)",
          borderBottom: `1px solid ${C.border}`, display: "flex", alignItems: "center",
          padding: "0 20px", gap: 12,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1 }}>
            <div style={{
              width: 34, height: 34, borderRadius: 9,
              background: `linear-gradient(135deg, ${C.primary}, ${C.primaryDark})`,
              display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden",
            }}>
              <img src="/logo.webp" alt="CuadraAI" width="34" height="34" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </div>
            <span style={{ color: C.text, fontWeight: 800, fontSize: 15 }}>CuadraAI</span>
          </div>
          <button onClick={onLogin} style={{
            background: "transparent", color: C.muted, border: `1px solid ${C.border}`,
            borderRadius: 10, padding: "12px 16px", minHeight: 44, fontWeight: 700, fontSize: 13,
            fontFamily: "inherit", cursor: "pointer",
          }}>Iniciar sesión</button>
          <button onClick={onRegister} style={{
            background: C.primary, color: "#fff", border: "none",
            borderRadius: 10, padding: "12px 18px", minHeight: 44, fontWeight: 800, fontSize: 13,
            fontFamily: "inherit", cursor: "pointer", boxShadow: `0 4px 14px ${C.primary}40`,
          }}>Crear cuenta</button>
        </header>

        <main>
          <Hero C={C} onLogin={onLogin} onRegister={onRegister} />
          <div id="caracteristicas"><Features C={C} /></div>
          <HowItWorks C={C} />
          <Screenshots C={C} />
          <Benefits C={C} />
          <Testimonials C={C} />
          <FAQ C={C} />
        </main>
        <Footer C={C} onNavigate={onNavigate} />
      </div>
    </div>
  );
}